// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-table {
  position: relative;
}
.data-table-disable-pointer-events .data-table {
  pointer-events: none;
}
.data-table-disable-pointer-events .data-table .native-sortable.native-sortable.native-sortable__list {
  pointer-events: none;
}
.data-table__nav {
  width: 100%;
  z-index: 30;
  padding: 0 2rem;
  background-color: #fff;
  padding-top: 0.667rem;
  padding-bottom: 0.667rem;
  border-top: solid 0.084rem #dce1e5;
  top: -0.084rem;
}
.data-table__nav_sticky {
  background: #fff;
  transition: width 0.1s ease;
}
.data-table__nav_empty {
  display: none;
}
.data-table__nav:not(.data-table__nav_sticky) {
  border-bottom: 0.084rem solid #dce1e5;
  margin-left: 0 !important;
}
.data-table__hovered {
  position: absolute;
  bottom: -0.084rem;
  border-bottom: 0.25rem solid #bbcbd9;
  width: 100%;
  left: 0;
  display: none;
  height: 0;
}
.data-table__headers .data-table__row_fixed .data-table__cell:last-child::before {
  min-height: 100%;
}
.data-table__headers .data-table__cell_hovered::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 0.167rem;
  left: 0;
  bottom: -1px;
  background-color: #bbcbd9;
  z-index: 10;
}
.data-table__headers_absolute {
  position: absolute;
}
.data-table__navigation-container {
  clear: both;
  position: sticky;
  bottom: 0;
  z-index: 30;
}
.data-table__table {
  display: table;
  table-layout: fixed;
  width: var(--table-width, 'auto');
}
.data-table__table_size-m .data-table__row {
  height: 2.417rem;
}
.data-table__table_size-m .data-table__cell {
  font-size: 1rem;
}
.data-table__table_size-m .data-table__cell:not(.data-table__cell_v-align-middle) {
  padding: 0.417rem 0.667rem 0;
}
.data-table__table_simple {
  table-layout: auto;
}
.data-table__table_border {
  border-bottom: solid 1px #dce1e5;
  border-top: solid 1px #dce1e5;
}
.data-table__table_resizable::after {
  content: '';
  top: 0;
  position: absolute;
  height: 100%;
  width: 2px;
  background-color: #e88f36;
  z-index: 20;
  right: 0;
}
.data-table__table .data-table__native-sortable {
  display: table-row;
}
.data-table__thead {
  display: table-header-group;
}
.data-table__thead .data-table__row {
  height: inherit;
}
.data-table__thead .data-table__cell:empty {
  border: 0;
  height: 0;
  padding: 0;
}
.data-table__thead + .data-table__tbody_tree .data-table__row:first-child .data-table__cell {
  border-top: 0;
}
.data-table__tbody {
  display: table-row-group;
}
.data-table__tbody_tree .data-table__row:nth-child(odd):not(.data-table__row_hovered) {
  background-color: #f8f9fa;
}
.data-table__tbody_tree .data-table__row:nth-child(odd):not(.data-table__row_hovered).data-table__row_highlight-suggest {
  background-color: #e3f4f4;
}
.data-table__tbody_tree .data-table__row:nth-child(odd):not(.data-table__row_hovered).data-table__row_highlight-inactive {
  background-color: #eaedef;
}
.data-table__tbody:not(.data-table__tbody_tree):not(.data-table__tbody_zebra-reverse) .data-table__row:nth-child(odd):not(.data-table__row_hovered) {
  background-color: #f8f9fa;
}
.data-table__tbody:not(.data-table__tbody_tree):not(.data-table__tbody_zebra-reverse) .data-table__row:nth-child(odd):not(.data-table__row_hovered).data-table__row_highlight-suggest {
  background-color: #e3f4f4;
}
.data-table__tbody:not(.data-table__tbody_tree):not(.data-table__tbody_zebra-reverse) .data-table__row:nth-child(odd):not(.data-table__row_hovered).data-table__row_highlight-inactive {
  background-color: #eaedef;
}
.data-table__tbody_zebra-reverse .data-table__row:nth-child(even):not(.data-table__row_hovered) {
  background-color: #f8f9fa;
}
.data-table__tbody_zebra-reverse .data-table__row:nth-child(even):not(.data-table__row_hovered).data-table__row_highlight-suggest {
  background-color: #e3f4f4;
}
.data-table__tbody_zebra-reverse .data-table__row:nth-child(even):not(.data-table__row_hovered).data-table__row_highlight-inactive {
  background-color: #eaedef;
}
.data-table__tbody .data-table__row {
  background-color: #fff;
}
.data-table__tbody .data-table__row_fixed .data-table__cell:first-child {
  padding-left: 2rem;
}
.data-table__tbody .data-table__row_main {
  background-color: #eaedef !important;
  font-weight: 600;
}
.data-table__tbody .data-table__row_main.data-table__row_fixed .data-table__cell {
  pointer-events: all;
}
.data-table__tbody .data-table__row_main.data-table__row_fixed.data-table__row_hovered:not(.data-table__row_main-collapsed) .data-table__cell:last-child::before {
  background-color: #dce1e5;
  box-shadow: none;
}
.data-table__tbody .data-table__row_main.data-table__row_main-collapsed.data-table__row_hovered {
  background-color: #dceffa !important !important;
}
.data-table__tbody .data-table__row_main.data-table__row_main-collapsed.data-table__row_hovered .data-table__cell {
  background-color: transparent;
}
.data-table__tbody .data-table__row_main.data-table__row_main-collapsed.data-table__row_hovered .data-table__cell:first-child {
  border-left-color: transparent;
}
.data-table__tbody .data-table__row_main.data-table__row_main-collapsed.data-table__row_hovered .data-table__cell > * {
  opacity: 1;
}
.data-table__tbody .data-table__row_main.data-table__row_main-collapsed.data-table__row_hovered:last-child .data-table__cell {
  border-bottom-color: #dce1e5;
}
.data-table__tbody .data-table__row_main.data-table__row_main-collapsed .data-table__cell {
  pointer-events: all;
}
.data-table__tbody .data-table__row_main .data-table__cell {
  background-color: transparent;
  border-left-color: transparent;
  pointer-events: none;
}
.data-table__tbody .data-table__row_main-total {
  font-weight: 600;
}
.data-table__tbody .data-table__cell {
  border-left: solid 0.084rem transparent;
  width: auto !important;
}
.data-table__tbody .data-table__cell:first-child {
  border-left: none;
}
.data-table__tbody .data-table__cell:empty::before {
  content: '\\00A0';
  line-height: 1.5rem;
}
.data-table__tbody .data-table__cell_current-hovered {
  border-left: 0.084rem solid #bbcbd9;
  border-right: 0.084rem solid #bbcbd9;
  background-color: #dceffa;
}
.data-table__tbody .data-table__cell_current-hovered > * {
  opacity: 1;
}
.data-table__tbody .data-table__cell-0 {
  border-left: none;
}
.data-table__row {
  display: table-row;
  height: var(--row-height, 2rem);
}
.data-table__row.data-table__row_hovered {
  background-color: #dceffa  !important;
}
.data-table__row.data-table__row_hovered .data-table__cell {
  background-color: transparent;
}
.data-table__row.data-table__row_hovered .data-table__cell:first-child {
  border-left-color: transparent;
}
.data-table__row.data-table__row_hovered .data-table__cell > * {
  opacity: 1;
}
.data-table__row.data-table__row_hovered:last-child .data-table__cell {
  border-bottom-color: #dceffa;
}
.data-table__row.data-table__row_highlight-suggest {
  background-color: #e3f4f4;
}
.data-table__row.data-table__row_highlight-inactive {
  background-color: #eaedef;
}
.data-table__row_fixed .data-table__cell:last-child {
  border-right: none;
  height: inherit;
}
.data-table__row_fixed .data-table__cell:last-child::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: -1px;
  width: 2px;
  right: 0;
  background-color: #dce1e5;
}
.data-table__row_fixed .data-table__cell:last-child .data-table__resizable-handle {
  right: -0.417rem;
}
.data-table__row_fixed .data-table__cell:last-child .data-table__resizable-handle::before {
  width: 2px;
}
.data-table__row_fixed.data-table__row_hovered .data-table__cell:last-child::before {
  background-color: #bbcbd9;
}
.data-table__cell {
  display: table-cell;
  border-right: solid 1px #dce1e5;
  height: inherit;
  vertical-align: top;
  padding: 3px 1rem 0;
  position: relative;
}
.on-resize .data-table__cell {
  pointer-events: none;
}
.data-table__cell.data-table__cell li,
.data-table__cell.data-table__cell p,
.data-table__cell.data-table__cell span,
.data-table__cell.data-table__cell div {
  line-height: 1.5rem;
}
.data-table__cell .disabled {
  color: #657682;
}
.data-table__cell_bottom-hovered {
  border-bottom-color: #bbcbd9;
}
.data-table__cell_right-hovered {
  border-right-color: #bbcbd9;
}
.data-table__cell_hovered {
  background-color: #dceffa;
}
.data-table__cell_right-padding {
  padding-right: 0;
}
.data-table__cell_header-cell {
  border-bottom: solid 1px #dce1e5;
  background-color: #fff;
  font-size: 1rem;
  padding: 0;
}
.data-table__cell_hoverable:hover {
  background-color: #dceffa;
}
.data-table__cell_v-align-middle {
  vertical-align: middle;
  padding-top: 0;
  padding-bottom: 0;
}
.data-table__cell_v-align-baseline {
  vertical-align: baseline;
}
.data-table__cell_v-align-bottom {
  vertical-align: bottom;
}
.data-table__cell_v-align-top {
  vertical-align: top;
}
.data-table__cell-placeholder {
  display: table-cell;
  padding: 0;
  border: none;
}
.data-table__virtualized-cells-area {
  display: table;
  width: 100%;
}
.data-table__resizable-handle {
  position: absolute;
  z-index: 50;
  right: -0.584rem;
  top: -1px;
  bottom: -1px;
  width: 1.084rem;
  cursor: col-resize;
  opacity: 0;
  transition: opacity 0.15s linear;
  pointer-events: all;
}
.data-table__resizable-handle:hover {
  opacity: 1;
}
.data-table__resizable-handle_resize {
  opacity: 1;
}
.data-table__resizable-handle::before {
  content: '';
  top: 0;
  position: absolute;
  background-color: #e88f36;
  width: 1px;
  left: 0.5rem;
  height: 100%;
}
.on-resize {
  cursor: col-resize !important;
}
.on-resize body {
  pointer-events: none;
}
.data-table__checkbox-indent {
  position: relative;
  height: 1.5rem;
}
.data-table__tree-expander .checkbox-button__label {
  padding-bottom: 0.084rem;
  line-height: 1.4;
}
.data-table__table-header {
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
}
.data-table__table-header.data-table__table-header {
  height: var(--header-row-height, 3.333rem);
}
.data-table__table-header_xxs {
  padding: 0.667rem 0.167rem;
}
.data-table__table-header_xs {
  padding: 0.667rem 0.334rem;
}
.data-table__table-header_s {
  padding: 0.667rem 0.667rem;
}
.data-table__table-header_sm {
  padding: 0.667rem 1rem;
}
.data-table__table-header_m {
  padding: 0.667rem 1.334rem;
}
.data-table__table-header_l {
  padding: 0.667rem 2rem;
}
.data-table__table-header_xl {
  padding: 0.667rem 2.667rem;
}
.data-table__table-header_xls {
  padding: 0.667rem 4rem;
}
.data-table__table-header_xxl {
  padding: 0.667rem 5.334rem;
}
.data-table__table-header_xxxl {
  padding: 0.667rem 10.667rem;
}
.data-table__table-header_top {
  align-items: flex-start;
}
.data-table__table-header_bottom {
  align-items: flex-end;
}
.data-table__table-header_subtitle {
  display: block;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 22px;
}
.data-table__table-header_link {
  overflow: hidden;
}
.data-table__table-header_active:hover .data-table__hovered {
  display: block;
}
.data-table__table-header_fixed {
  padding-left: 2rem;
}
.data-table__table-header_fixed .table-header__title {
  padding-left: 1.668rem;
}
.data-table .data-table__cell_hovered .data-table__table-header {
  background-color: #dceffa;
}
.data-table .data-table__cell_hovered .data-table__table-header .data-table__hovered {
  display: block;
}
.data-table .data-table__cell_hovered .data-table__table-header_active .data-table__hovered {
  display: block;
}
.data-table__table-header:hover .table-header-info__info {
  opacity: 1;
}
.data-table .native-sortable__wrapper {
  display: table-row-group;
}
.data-table__native-sortable_fallback {
  background: #fef3db !important;
}
.data-table__native-sortable .native-sortable__remove .native-sortable__filter {
  display: none;
}
.data-table__cell-loading {
  position: absolute;
  top: 0;
  bottom: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: rgba(255,255,255,0.8);
}
.data-table__message {
  padding: 1rem;
  text-align: center;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
